import * as constants from './constants'
import { fromJS } from 'immutable'

// 初始默认的state
const defaultState = fromJS({
  loginStatu: false
})

const setStatu = (state, action) => {
  return state.set('loginStatu', action.statu)
}

// 简便写法 第一种等同于第二种
// return { ... state , [counterCaption] : state [counterCaption] + 1} ;

// const newState =Object . assign ( {} , state );
// newState[counterCaption] ++ ;
// return newState ;

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
  switch (action.type) {
    case constants.SET_STATU:
      return setStatu(state, action)
    default:
      return state
  }
}
